// extracted by mini-css-extract-plugin
export default {"door":"door_door__vZWED","fg":"door_fg__fSNUJ","open":"door_open__9e7po","bg":"door_bg__9n1Qu"};